import React, { useState, useEffect } from 'react';
import {
    Card, CardBody, CardHeader, Container, Input, Table, Button, Row, Col, InputGroup, Modal, ModalBody,
    ModalHeader
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faReply, faPhone, faGlobe, faCalendar, faMapMarkerAlt, faEye, faTrash, faTimes, faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import Pagination from "react-js-pagination";
import requestApi from '../../../services/requestApi.service';
import { showToast } from '../../../Common/Appcommon';
import cx from 'classnames';
import CreateRCSTemplate from './CreateTemplate';
const RCSTemplatesSettings = () => {
    const [activePage, setActivePage] = useState(1);
    const [searchBy, setSearchBy] = useState('');
    const [view, setView] = useState('list'); // 'list' or 'create'
    const [activeCardIndex, setActiveCardIndex] = useState(0);

    // Dummy data to mimic the screenshot
    const [templates, setTemplates] = useState([]);

    useEffect(() => {
        if (view === 'list') {
            loadTemplates();
        }
    }, [view]);

    // Modal State
    const [modalOpen, setModalOpen] = useState(false);
    const [previewData, setPreviewData] = useState(null);
    const [previewLoading, setPreviewLoading] = useState(false);

    // Selection State
    const [selectedIds, setSelectedIds] = useState([]);

    const toggleModal = () => setModalOpen(!modalOpen);

    const handleSelectAll = (e) => {
        if (e.target.checked) {
            const allIds = templates.map(t => t.tempid).filter(id => id); // Ensure ID exists
            setSelectedIds(allIds);
        } else {
            setSelectedIds([]);
        }
    };

    const handleSelectRow = (id, e) => {
        if (!id) return;
        if (e.target.checked) {
            setSelectedIds([...selectedIds, id]);
        } else {
            setSelectedIds(selectedIds.filter(itemId => itemId !== id));
        }
    };

    const handleDelete = async () => {
        if (selectedIds.length === 0) {
            showToast("Please select at least one template to delete", "top-right", "warn");
            return;
        }

        if (!window.confirm("Are you sure you want to delete the selected templates?")) {
            return;
        }

        const params = {
            ENTITY: "FORMPROCESS",
            OPERATION: "deleteRCSTemplates",
            ids: selectedIds.join(',')
        };

        try {
            const response = await requestApi.processServerRequest(params);
            if (response && response.issuccess) {
                showToast(response.msg || "Templates deleted successfully");
                setSelectedIds([]);
                loadTemplates();
            } else {
                showToast(response.msg || "Failed to delete templates", "top-right", "error");
            }
        } catch (error) {
            console.error("Delete error:", error);
            showToast("An error occurred while deleting", "top-right", "error");
        }
    };

    const getButtonIcon = (type) => {
        switch (type) {
            case 'reply': return <FontAwesomeIcon icon={faReply} className="me-1" />;
            case 'dial': return <FontAwesomeIcon icon={faPhone} className="me-1" />;
            case 'url': return <FontAwesomeIcon icon={faGlobe} className="me-1" />;
            case 'calendar': return <FontAwesomeIcon icon={faCalendar} className="me-1" />;
            case 'location': return <FontAwesomeIcon icon={faMapMarkerAlt} className="me-1" />;
            default: return null;
        }
    };

    const handlePreview = (template) => {
        setPreviewData(template);
        setActiveCardIndex(0);
        setModalOpen(true);
    };

    const loadTemplates = async () => {
        const params = {
            ENTITY: "FORMPROCESS",
            OPERATION: "getRCSTemplates",
        };

        try {
            const response = await requestApi.processServerRequest(params);
            if (response && response.issuccess) {
                setTemplates(response.data);
            }
        } catch (error) {
            console.error("Get error:", error);
        }
    }

    if (view === 'create') {
        return <CreateRCSTemplate onCancel={() => setView('list')} />;
    }

    return (
        <div className="listview-container kv-main-wrapper h100per w-100 rcs-templates-view">
            <div className="col-xl-12 col-lg-12 col-md-12 m-auto mt-2">
                <Container fluid>
                    <Card className="main-card border mb-3">
                        {/* Header with Search and Actions */}
                        <CardHeader className="d-flex justify-content-between align-items-center bg-white border-0 pt-3 pb-3">
                            <div className="search-wrapper d-flex gap-2 hide" style={{ minWidth: '600px' ,contentVisibility:'hidden'}}>
                                <div style={{ width: '200px' }}>
                                    <Input
                                        type="select"
                                        className="form-control-sm"
                                        value={searchBy}
                                        onChange={(e) => setSearchBy(e.target.value)}
                                    >
                                        <option value="">Search By</option>
                                        <option value="Template Name">Template Name</option>
                                        <option value="Template ID">Template ID</option>
                                        <option value="Bot Name">Bot Name</option>
                                        <option value="Bot ID">Bot ID</option>
                                        <option value="Status">Status</option>
                                    </Input>
                                </div>
                                {searchBy && (
                                    <>
                                        <InputGroup style={{ width: '300px' }}>
                                            <Input
                                                placeholder={`Enter ${searchBy}`}
                                                className="form-control-sm"
                                            />
                                            <Button color="primary" className="btn-icon">
                                                <i className="fa fa-search"></i>
                                            </Button>
                                        </InputGroup>
                                        <Button color="primary" className="btn-icon">
                                            <i className="fa fa-refresh"></i>
                                        </Button>
                                    </>
                                )}
                            </div>
                            <div className="action-wrapper d-flex gap-2">
                                <Button color="outline-danger" className="btn-icon" onClick={handleDelete}>
                                    <FontAwesomeIcon icon={faTrash} />
                                </Button>
                                <Button
                                    color="success"
                                    className="btn-wide btn-shadow text-white"
                                    onClick={() => setView('create')}
                                >
                                    Create Template
                                </Button>
                            </div>
                        </CardHeader>

                        <CardBody className="p-0">
                            <Table striped responsive hover className="mb-0 text-center align-middle custom-table" style={{ width: "150%" }}>
                                <thead className="bg-light">
                                    <tr>
                                        <th>
                                            <Input
                                                type="checkbox"
                                                onChange={handleSelectAll}
                                                checked={templates.length > 0 && selectedIds.length === templates.length}
                                            />
                                        </th>
                                        {/* <th>User ID</th> */}
                                        <th>Template Name</th>
                                        <th>Template ID</th>
                                        <th>Template Type</th>
                                        {/* <th>Bot Name</th> */}
                                        <th>Bot Id</th>
                                        <th>Last Updated</th>
                                        <th>Status</th>
                                        <th>Reason</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {templates.map((tpl, index) => (
                                        <tr key={index}>
                                            <td>
                                                <Input
                                                    type="checkbox"
                                                    checked={selectedIds.includes(tpl.tempid)}
                                                    onChange={(e) => handleSelectRow(tpl.tempid, e)}
                                                />
                                            </td>
                                            {/* <td>{tpl.Username ? tpl.Username : <span className="text-danger">MISSING ID</span>}</td> */}
                                            <td>{tpl.templateName}</td>
                                            <td className="" style={{ maxWidth: '150px', wordBreak: 'break-all' }}>{tpl.Template_ID}</td>
                                            <td>{tpl.templateType}</td>
                                            {/* <td>{tpl.botName}</td> */}
                                            <td>{tpl.Bot_Id}</td>
                                            <td>{tpl.updatedon}</td>
                                            <td>
                                                <span className={cx("badge p-2", {
                                                    'badge-soft-success': tpl.Status === 'Approved',
                                                    'badge-soft-danger': tpl.Status === 'Rejected',
                                                    'badge-soft-warning': tpl.Status === 'Pending',
                                                    'badge-soft-secondary': tpl.Status !== 'Approved' && tpl.Status !== 'Rejected' && tpl.Status !== 'Pending'
                                                })}>
                                                    {tpl.Status}
                                                </span>
                                            </td>
                                            <td>{tpl.Reason}</td>
                                            <td>
                                                <Button color="link" size="sm" className="text-primary btn-icon" onClick={() => handlePreview(tpl)}>
                                                    <FontAwesomeIcon icon={faEye} className="text-primary" style={{ fontSize: '1.2rem' }} />
                                                </Button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>

                            {/* Pagination Footer */}
                            <div className="d-flex justify-content-end align-items-center p-3 border-top">
                                <div className="me-3 text-muted small">Items per page: 10</div>
                                <div className="me-3 text-muted small">1 - 1 of 1</div>
                                <Pagination
                                    activePage={activePage}
                                    itemsCountPerPage={10}
                                    totalItemsCount={1}
                                    pageRangeDisplayed={5}
                                    onChange={(page) => setActivePage(page)}
                                    itemClass="page-item"
                                    linkClass="page-link"
                                    prevPageText="‹"
                                    nextPageText="›"
                                    firstPageText="«"
                                    lastPageText="»"
                                />
                            </div>
                        </CardBody>
                    </Card>
                </Container>
            </div>


            {/* Preview Modal */}
            <Modal isOpen={modalOpen} toggle={toggleModal} centered style={{ justifyContent: 'center', maxWidth: '30%' }}>
                <ModalHeader toggle={toggleModal}>
                    Template Preview
                </ModalHeader>
                <ModalBody className="d-flex justify-content-center align-items-center p-2">
                    {previewLoading ? (
                        <div className="text-center p-5">Loading...</div>
                    ) : previewData ? (
                        /* Reuse the card preview UI logic. Assuming previewData has 'cards' array. */
                        /* If backend logic saves 'cards', we iterate. For simplicity, show first card or handle Carousel */
                        (previewData.cards && previewData.cards.length > 0) ? (
                            <div className="bg-light rounded p-3 overflow-hidden shadow-sm position-relative" style={{ width: previewData.cardWidth === 'medium' ? '360px' : '300px', minHeight: 'auto', display: 'flex', flexDirection: 'column' }}>
                                {previewData.cards.map((card, idx) => (
                                    <div key={idx} style={{ display: idx === activeCardIndex ? 'block' : 'none' }}>
                                        {/* Media section - Only show if NOT a Standard template and media exists */}
                                        {((previewData.templateType && !previewData.templateType.includes('Standard')) || 
                                          (previewData.template_type && !previewData.template_type.includes('Standard'))) && 
                                          (card.imageContent || card.videoContent || card.mediaUrl) && (
                                            <div className="w-100 mb-2 position-relative" style={{ height: '120px', overflow: 'hidden' }}>
                                                {card.imageContent || card.mediaUrl ? (
                                                    <img src={card.imageContent || card.mediaUrl} alt="Preview" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                                ) : (
                                                    <video src={card.videoContent} controls style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                                )}

                                                {/* Navigation Arrows for Carousel inside Media */}
                                                {(previewData.templateType?.includes('Carousel') || previewData.template_type?.includes('Carousel')) && previewData.cards.length > 1 && (
                                                    <>
                                                        {activeCardIndex > 0 && (
                                                            <div className="wa-preview-arrow wa-preview-arrow-left" onClick={(e) => { e.stopPropagation(); setActiveCardIndex(activeCardIndex - 1); }} style={{ position: 'absolute', left: '5px', top: '50%', transform: 'translateY(-50%)', background: 'white', borderRadius: '50%', width: '25px', height: '25px', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', boxShadow: '0 1px 3px rgba(0,0,0,0.3)', zIndex: 10 }}>
                                                                <FontAwesomeIcon icon={faChevronLeft} style={{ fontSize: '12px' }} />
                                                            </div>
                                                        )}
                                                        {activeCardIndex < previewData.cards.length - 1 && (
                                                            <div className="wa-preview-arrow wa-preview-arrow-right" onClick={(e) => { e.stopPropagation(); setActiveCardIndex(activeCardIndex + 1); }} style={{ position: 'absolute', right: '5px', top: '50%', transform: 'translateY(-50%)', background: 'white', borderRadius: '50%', width: '25px', height: '25px', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', boxShadow: '0 1px 3px rgba(0,0,0,0.3)', zIndex: 10 }}>
                                                                <FontAwesomeIcon icon={faChevronRight} style={{ fontSize: '12px' }} />
                                                            </div>
                                                        )}
                                                    </>
                                                )}
                                            </div>
                                        )}

                                        {/* Fallback navigation if NO media exists but is a carousel */}
                                        {((previewData.templateType?.includes('Carousel') || previewData.template_type?.includes('Carousel')) && 
                                          !(card.imageContent || card.videoContent || card.mediaUrl) && 
                                          previewData.cards.length > 1) && (
                                            <div className="d-flex justify-content-between align-items-center mb-2">
                                                <Button size="sm" color="link" disabled={activeCardIndex === 0} onClick={() => setActiveCardIndex(activeCardIndex - 1)}>
                                                    <FontAwesomeIcon icon={faChevronLeft} /> Prev
                                                </Button>
                                                <span className="small text-muted">{activeCardIndex + 1} / {previewData.cards.length}</span>
                                                <Button size="sm" color="link" disabled={activeCardIndex === previewData.cards.length - 1} onClick={() => setActiveCardIndex(activeCardIndex + 1)}>
                                                    Next <FontAwesomeIcon icon={faChevronRight} />
                                                </Button>
                                            </div>
                                        )}

                                        <div className="p-3 flex-grow-1 bg-white">
                                            <h5>{card.title || <span className="text-muted">Title</span>}</h5>
                                            <p className="small">{card.body || <span className="text-muted">Body text...</span>}</p>
                                        </div>
                                        <div className="mt-auto">
                                            {card.buttons && card.buttons.map((btn, i) => (
                                                <div key={i} className="text-center py-2 text-primary border-top small fw-bold">
                                                    {getButtonIcon(btn.type)} {btn.text}
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <div>No Preview Available</div>
                        )
                    ) : (
                        <div>Failed to load preview</div>
                    )}
                </ModalBody>
            </Modal>
        </div >
    );
};

export default RCSTemplatesSettings;
